import React from "react";
const IconGiftCard = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M2 15V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m6.59 6.97.009-.002a1.813 1.813 0 0 1 1.45.266l.009.005c.413.29.917.881 1.339 1.524l1.064 1.626-1.942-.079a5.633 5.633 0 0 1-2.218-.554l-.007-.003a1.405 1.405 0 0 1-.523-.472 1.735 1.735 0 0 1-.265-.617V8.66c-.038-.182-.118-.72.276-1.187l.005-.006c.21-.245.49-.419.803-.498Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m13.631 6.97-.01-.002a1.813 1.813 0 0 0-1.45.266l-.008.005c-.414.29-.918.881-1.339 1.524L9.76 10.39l1.942-.079a5.633 5.633 0 0 0 2.219-.554l.007-.003c.262-.13.433-.34.523-.472.11-.162.213-.371.264-.617l.001-.003c.038-.182.118-.72-.276-1.187l-.005-.006a1.56 1.56 0 0 0-.803-.498Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth="2"
      d="m10.098 10.1 2.437 2.438M10.098 10.1 7.66 12.538"
    />
  </svg>
);
export default IconGiftCard;
